export { default } from './ClickableTable';
